export const AdminLOADING = "admin/Loading";
export const AdminERROR = "admin/Error";
export const AdminUsersListSUCCESS = "admin/UsersListSuccess";
export const AdminUserUpdateSUCCESS = "admin/UserUpdateSuccess";
export const AdminUserDeleteSUCCESS = "admin/UserDeleteSuccess";
export const AdminOrgsListSUCCESS = "admin/OrgsListSuccess";
